
import {v4 as uuid} from "uuid";
import {PropType} from 'vue';
import {MapBuilder} from '../../../../../src/Map';

export default {
    props: {
        mapColumn: {
            type: Object as PropType<any>,
        }
    },
    mounted() {
        const map = new MapBuilder(document.getElementById(this.id)).makeDefault();

        const geoObject = this.mapColumn.mapElement?.value?.geoObject;
        if (geoObject) {
            this.$nextTick(() => {
                map.addGeoObject(JSON.parse(geoObject));
            });
        }
    },
    data() {
        return {
            id: uuid(),
        }
    }
}
